import { useLayoutEffect } from 'react';

import { pageUI } from '@modules/shared/constants';

import { formatActivityTime } from '../utils';

const useAllDayCheckbox = ({ start, end, form, page }) => {
  const { setFieldsValue, getFieldsValue } = form;
  const allDay = getFieldsValue().allDay;
  const pageValue = page && page.valueOf();

  const startValue = start && start.valueOf();
  const endValue = end && end.valueOf();
  const allDayEndTime = [pageUI.ACTIVITY, pageUI.EVENT].includes(pageValue)
    ? '23:45'
    : '23:59';
  const skipAllDayReassignation = pageValue === pageUI.EVENT && allDay;

  useLayoutEffect(() => {
    if (start && end && !skipAllDayReassignation) {
      const formattedStartTime = formatActivityTime(startValue);
      const formattedEndTime = formatActivityTime(endValue);
      const result =
        formattedEndTime === allDayEndTime && formattedStartTime === '00:00';

      if (result !== allDay) {
        setFieldsValue({ allDay: result });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startValue, endValue, setFieldsValue, pageValue]);

  return allDay;
};

export default useAllDayCheckbox;
